import React, { useEffect, useState } from "react";
import Account from "./containers/Account/Account";
import Security from "./containers/Security/Security";
import Spinner from "./components/Spinner/Spinner";
import Gfn from "./containers/Gfn/Gfn";
import Gfe from "./containers/Gfe/Gfe";
import Redeem from "./containers/Redeem/Redeem";
import { getLocale, isUserEnrolled } from "./utils/helpers";
import Starfleet from "./services/starfleet";
import { useTranslation } from "react-i18next";
import { getSubscription } from "./services/gfn";
import { getPreferences } from "./services/voltron";
import { H1, P } from "./styles";
import { GFN_EXCLUSION_LIST } from "../config/gfn-config";

const locale = getLocale();

const starfleet = new Starfleet(
  locale === "zh-cn" ? STARFLEET_BASE_CN : STARFLEET_BASE,
  {
    SESSION_ITEM_NAME,
    CLIENT_ID,
    LAST_LOGIN,
    SUPPORTED_IDPS,
    PRIVACY_ITEM_NAME,
    LOGIN_HINTS_ITEM_NAME,
  }
);

const App = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [productId, setProductId] = useState("");
  const [currentPlan, setCurrentPlan] = useState("");
  const [subsReady, setSubsReady] = useState(null);
  const [rewardsReady, setRewardsReady] = useState(true);
  const [enrolled, setEnrolled] = useState(false);
  const [idToken, setIdToken] = useState("");
  let session = {};
  useEffect(() => {
    (async () => {
      session = await starfleet.getSession(locale);

      // session does not exist
      // send the user to login
      if (!session) {
        starfleet.authorize(locale);
        return null;
      }
      const profileResponse = await starfleet.getProfile(session.access_token);
      setIdToken(session.id_token);
      const parsedConsent =
        JSON.parse(sessionStorage.getItem(PARSED_CONSENT_ITEM_NAME)) ?? {};

      setEmail(
        profileResponse.data.emails && profileResponse.data.emails[0].value
      );

      setDisplayName(profileResponse.data.displayName);
      setLoading(false);
      getPreferences(
        session.id_token,
        profileResponse?.data?.emails[0]?.value,
        locale
      ).then((response) => {
        setEnrolled(isUserEnrolled(response, parsedConsent));
        setRewardsReady(true);
      });

      // Only showing the GFN section for the supported locales
      if (!GFN_EXCLUSION_LIST.includes(locale)) {
        getSubscription(session.id_token, locale).then((response) => {
          setProductId(response.productId);
          setCurrentPlan(response.currentPlan);
          setSubsReady(true);
        });
      }
    })().catch((error) => {
      if (error && error?.response?.status === 403) {
        starfleet.authorize(locale);
      } else {
        console.log(error);
      }
    });
  }, []);

  if (loading) {
    return <Spinner />;
  } else
    return (
      <div style={{ maxWidth: "800px", width: "100%" }}>
        <H1>
          {t("Hi,")} {displayName}
        </H1>
        <P textAlign="center">
          {t(
            "Manage your account profile, privacy preferences, and security to customize your NVIDIA experience."
          )}
        </P>

        <Account email={email} displayName={displayName} locale={locale} />

        {subsReady && (
          <Gfn
            currentPlan={currentPlan}
            productId={productId}
            locale={locale}
          />
        )}

        {rewardsReady && <Gfe enrolled={enrolled} locale={locale} />}

        <Security
          email={email}
          locale={locale}
          clearStorage={() => starfleet.clearStorage()}
          idToken={idToken}
        />

        <Redeem locale={locale} />
      </div>
    );
};

export default App;
